export default __webpack_public_path__ + "static/media/six_of_swords.5f764c50.png";